var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"app":this}})],1),(_vm.show)?_c('logout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }